export const INTERVALS_IN_MONTHS = [6, 12, 24, 60]; // 6 months, 1 year, 2 years, 5 years

export const MAX_FOLLOWUP_INTERVAL_IN_MONTHS = 60; // 5 years
